export default [{
  name: 'lojadomecanico',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaBanco: {},
        PessoaEndereco: {},
        PessoaDadosContato: {},
        DocumentoFederal: ''
      },
      Parcela: {},
      ObservacaoVendedor: null
    },
    dadosIniciais: {
      pessoaParceiroLimiteCredito: {}
    },
    pessoa: {
      PessoaBanco: {},
      PessoaEndereco: {},
      PessoaDadosContato: {},
      DocumentoFederal: ''
    },
    produtoRede: {}
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    },
    produtoRede (state, obj) {
      state.produtoRede = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    },
    produtoRede (state) {
      return state.produtoRede
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaEndereco: {},
          PessoaDadosContato: {},
          DocumentoFederal: ''
        },
        Parcela: {},
        ObservacaoVendedor: null,
        Proposta: {}
      }
      commit('model', data)
      commit('dadosIniciais', { pessoaParceiroLimiteCredito: {} })
    },
  }
}]
